import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { getPlantData, getClimateData } from "../../store/design/actions"
import ReactApexChart from "react-apexcharts"
import { getAreas, updateArea, deleteArea, addArea } from "../../store/goals/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import Spreadsheet from "react-spreadsheet";
import { useDrag, useDrop } from "react-dnd";
import {
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardImgOverlay,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import { Image } from '@aws-amplify/ui-react';
import { Storage } from '@aws-amplify/storage'

const type = "GuildFunction";

const GuildElement = props => {
  const { areaIndex, plantIndex, plant } = props
  
  const [{ isDragging }, drag] = useDrag(() => (
    {
    type: 'guildelement',
    item: { plant: plant, area: areaIndex  },
    collect: (monitor) => {
      return {
        isDragging: monitor.isDragging(),
      };
    },
  }));

  return (
              <div ref={drag}><Card outline color="success" className="border">
                   <CardTitle>
                      {plant.species}
                   </CardTitle>
              </Card></div>
   );
}
export default GuildElement;
